const { v4: uuidv4 } = require("uuid");
const {
  GiLovers,
  GiTrophy,
  GiPartyPopper,
  GiHumanPyramid,
  GiMountainCave,
} = require("react-icons/gi");
const {
  FaPeopleCarry,
  FaCarSide,
  FaTheaterMasks,
  FaChild,
} = require("react-icons/fa");
const { FiGift } = require("react-icons/fi");
const { HiOutlineUserGroup } = require("react-icons/hi");
export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: false,
  lightTextDesc: false,
  headline: "Despre Noi",
  description:
    "Grădiniţa „Roza Venerini” din Pildești, aparţine Congregaţiei Maestre Pie Venerini. Ea poartă numele fondatoarei Congregaţiei, Roza Venerini, care a deschis în Italia prima şcoală feminină publică în anul 1685. Grădiniţa a fost construită în perioada 1996-1999  la capătul satului Pildeşti, un sat mare şi primitor, cu oameni harnici, şi a fost inaugurată în anul 2000. În anul 2010 s-au sărbătorit 10 ani de existență   printr-o sărbătoare, o sărbătoare a comunităţii surorilor Congregaţiei Maestre Pie Venerini, o sărbătoare a copiilor şi părinţilor, a satului. Suntem o instituţie de învăţământ acreditată şi aplicăm Curriculum pentru Educația Timpurie 2019. Aici sunt primiți copii de la 3-6 ani fără deosebire de apartenenţă religioasă, status social sau etnie.mAn de an este îmbunătăţită baza materială a grădiniţei astfel încât să fie asigurate spaţiul şi materiale didactice conform cerinţelor curriculare. Resurse materiale suficiente cantitativ, accesibile, funcţionale, permit individualizarea instruirii Grădiniţa dispune de ample spaţii: săli de grupă pentru activităţile instructiv-educative dotate cu mobilier ergonomic, sală de joc cu multe mijloace de învăţământ pentru dezvoltarea psiho-motrică a copiilor, spaţii de joacă a copiilor în aer liber cu spațiu verde și aparate de joacă specifice vârstei copiilor.",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/sf-roza2.jpg").default,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjTwo = {
  id: "mission",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  headline: "Misiune",
  description:
    "Grădiniţa “Roza Venerini” este un centru educativ catolic care oferă o educaţie integrală copiilor înscrişi, fără deosebire de apartenenţă religioasă, status social sau etnie. Ea pune copilul în centru atenţiei şi activităţii educative ca valoare umană supremă de a fi iubit, format şi pregătit.Tradiția educativă Venerini, construită de-a lungul timpului și care își are originea în îndepărtatul 1685, când Sfânta Roza Venerini a deschis prima scoală pentru copiii săraci din Italia inspiră și astăzi acțiunea noastră educativă care are ca finalitate dezvoltarea integrală şi armonioasă a copilului, conform principiilor creştine, având ca deviză: ” A educa pentru a elibera” , în vederea integrării senine în școală și societate.",
  buttonLabel: "Learn more",
  imgStart: true,
  img: require("../../images/car.svg").default,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "vision",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  headline: "Viziune",
  description:
    "Dorim ca grădinița noastră de inspirație ”Creștin-catolică” care își are rădăcinile în principiile evanghelice să fie atentă la exigențele și problemele copiilor, familiilor și a comunității locale. Vrem ca această instituție să fie o familie unde copiii să fie însoțiți cu iubire și grijă pe drumul către sensul responsabilității și autonomiei. Dorim ca această grădiniță să aibă mereu un colectiv deschis, primitor și pregătit fie sub profil didactic cât și etic-educativ.",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/true-friends.png").default,
  alt: "Paper",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjFour = {
  id: "offer",
  lightBg: false,
  lightText: false,
  lightTextDesc: false,
  headline: "Oferta Educationala",
  description:
    "Procesul instructiv-educativ se desfășoară Curriculumului Național pentru educație timpurie, adaptat și individualizat pentru nevoile și abilităţile fiecărui copil, fiind structurat pe domenii de dezvoltare.Pe langă trunchiul comun al curriculumu-lui, curriculum-ul la decizia grădiniţei (activităţi educationale) completează educaţia oferită copiilor, urmărind obiective ce vizează prioritar valorificarea intereselor şi aptitudinilor manifestate de copii.Grădinița desfășoară activități în parteneriat cu alte instituții de învățământ din județ, țară și străinătate, cu şi cu alţi parteneri educaţionali din comunitate ",
  buttonLabel: "Get Started",
  activity: [
    {
      id: uuidv4(),
      details: "„Daruri mici din suflet mare“",
      icon: <GiLovers />,
    },
    {
      id: uuidv4(),
      details: "„Oamenii de lângă noi“",
      icon: <FaPeopleCarry />,
    },
    {
      id: uuidv4(),
      details: "„Știu! Pot! Vreau să reușesc!“",
      icon: <GiTrophy />,
    },
    { id: uuidv4(), details: "„Știm să circulăm!“", icon: <FaCarSide /> },
    { id: uuidv4(), details: "„Poveste de Crăciun“", icon: <FiGift /> },
  ],
  activitiesTwo: [
    {
      id: uuidv4(),
      details: "Organizarea de serbari .",
      icon: <GiPartyPopper />,
    },
    {
      id: uuidv4(),
      details: "Participarea la concursuri, festivaluri, expoziții.",
      icon: <FaTheaterMasks />,
    },
    {
      id: uuidv4(),
      details: "Teatru de papusi.",
      icon: <FaChild />,
    },
    {
      id: uuidv4(),
      details:
        "Activităţi de voluntariat / sprijin pentru cei aflaţi în dificultate.",
      icon: <GiHumanPyramid />,
    },
    {
      id: uuidv4(),
      details:
        "Organizarea de excursii, momente distensive pentru copii și părinți",
      icon: <GiMountainCave />,
    },
  ],
  imgStart: true,
  img: require("../../images/PieVenerini.png").default,
  alt: "Paper",
  dark: false,
  primary: false,
  darkText: true,
};
